import React, { useState, useEffect } from 'react'
import jsPDF from 'jspdf'
import TextareaAutosize from 'react-textarea-autosize';

import { Row, Col, Container, Card, CardBody } from 'reactstrap';
const Output = ({ data }) => {

  const [text, setText] = useState([])
  
  useEffect(()=>{
    setText(data.OcrPages)
  }, [data])

  let array = text

  const downloadPdf = (e) => {
    e.preventDefault()
    var lMargin=15; 
    var rMargin=15;
    var pdfInMM=210;
    var doc = new jsPDF("p","mm","a4");
    var paragraph=pages;
    var lines =doc.splitTextToSize(paragraph, (pdfInMM-lMargin-rMargin));
    doc.text(lMargin,20,lines);
    doc.save('conerted.pdf')
  }
  const downloadDoc = (e) => {
    e.preventDefault()
    var lMargin=15; 
    var rMargin=15;
    var pdfInMM=210;
    var doc = new jsPDF("p","mm","a4");
    var paragraph=pages;
    var lines =doc.splitTextToSize(paragraph, (pdfInMM-lMargin-rMargin));
    doc.text(lMargin,20,lines);
    doc.save('conerted.doc')
  }

  

  let pages = []
   array.map((page) => {
    return pages.push(page.TextResult)
  }
  )
  console.log('page :'+ pages)

  return (
    <Container className="feature30">
      <Row>
        <Col lg="12" md="12" className="text-center">
          <Card className="card-shadow data-container">
            <CardBody className="“form-group"> {
              array.map((page) => <TextareaAutosize className="card-shadow form-control" type="text" value={page.TextResult} key={page.PageNumber} onChange={e => setText(e.target.value)} />  )
            }
             
          <div className="m-t-20">
          <button className="btn  bg-success-gradiant btn-md btn-arrow m-1" onClick={downloadPdf} type="submit"><span>Save As PDF <i className="ti-arrow-right"></i></span></button>
          <button className="btn  bg-success-gradiant btn-md btn-arrow m-1" onClick={downloadDoc} type="submit"><span>Save As Word <i className="ti-arrow-right"></i></span></button>
        </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default Output
